import axios from "axios"
import { baseURL } from "constants/api"

const apiRequest = async (method, pathname, data) => {
  try {
    const response = await axios.request({
      method,
      url: `${baseURL}/${pathname}`,
      data: method !== "GET" ? data : null,
    })
    return response.data
  } catch (error) {
    console.error(`Ошибка при выполнении запроса ${pathname}:`, error)
    throw error
  }
}

const apiGet = async (pathname) => apiRequest("GET", pathname)
const apiPut = async (pathname, body) => apiRequest("PUT", pathname, body)
const apiPost = async (pathname, body) => apiRequest("POST", pathname, body)
const apiDelete = async (pathname) => apiRequest("DELETE", pathname)

export const getRestaurant = (restaurant_id) =>
  apiGet(`restaurants/${restaurant_id}`).then((res) => res[0])

export const getSettings = (restaurant_id) =>
  apiGet(`settings/${restaurant_id}`)

export const getItems = (restaurant_id) => apiGet(`dishes/${restaurant_id}`)
export const putItem = (id, data) => apiPut(`dishes/${id}`, data)
export const postItem = (data) => apiPost(`dishes/`, data)
export const deleteItem = (id) => apiDelete(`dishes/${id}`)
export const getAddons = (item_id) => apiGet(`dishes/${item_id}/addons`)
export const getChoices = (item_id) => apiGet(`dishes/${item_id}/choices`)

export const getGroups = (restaurant_id) => apiGet(`groups/${restaurant_id}`)
export const putGroup = (data) => apiPut(`groups/`, data)
export const postGroup = (data) => apiPost(`groups/`, data)
export const deleteGroup = (id) => apiDelete(`groups/${id}`)
